import * as user from '../actions/user';
import {User} from '../models/user';
import {PagingModel} from '../models/paging-model';
import {KvItem} from '../models/kv-item';
import {UserListModel} from '../models/user-list-model';
import * as auth from '../actions/authentication';

export interface State {
  userPage: UserListModel[];
  paging: PagingModel;
  selectedUser: User;
  tempUser: User;
  selectedUsername: string;
  roles: KvItem[];
  isNewUser: boolean;
  working: boolean;
  usernameExists: boolean;
  emailExists: boolean;
}

export const initialState: State = {
  userPage: [],
  paging: {itemsPerPage: 25, totalItems: 0, totalPages: 0, pageNumber: 1 } as PagingModel,
  selectedUser: { enabled: true },
  selectedUsername: '',
  roles: [],
  tempUser: {},
  isNewUser: false,
  working: false,
  usernameExists: false,
  emailExists: false
};

export function reducer(state = initialState, action: any): State {
  let newState: State;

  switch (action.type) {

    case user.LOAD_USER_LIST:
      newState = Object.assign({}, state);
      newState.selectedUser = new User();
      newState.selectedUsername = '';
      newState.working = true;
      newState.paging = action.payload;
      return newState;

    case user.LOAD_USER_LIST_COMPLETE:
      newState = Object.assign({}, state);
      newState.userPage = action.payload.results;
      newState.paging = action.payload.paging;
      newState.working = false;
      return newState;

    case user.LOAD_USER_ROLES:
      newState = Object.assign({}, state);
      newState.working = true;
      return newState;

    case user.LOAD_USER_ROLES_COMPLETE:
      newState = Object.assign({}, state);
      newState.roles = action.payload;
      newState.working = false;
      return newState;

    case user.LOAD_USER_DETAILS:
      newState = Object.assign({}, state);
      newState.selectedUsername = action.payload;
      if (!action.payload) {
        newState.isNewUser = true;
        newState.selectedUser = initialState.selectedUser;
      } else {
        newState.isNewUser = false;
      }
      newState.working = true;
      return newState;

    case user.LOAD_USER_DETAILS_COMPLETE:
      newState = Object.assign({}, state);
      newState.selectedUser = action.payload;
      newState.working = false;
      return newState;

    case user.SAVE_USER_DETAILS:
      newState = Object.assign({}, state);
      newState.tempUser = action.payload;
      newState.working = true;
      return newState;

    case user.SAVE_USER_DETAILS_COMPLETE:
      newState = Object.assign({}, state);
      if (action.payload) {
        newState.selectedUser = Object.assign({}, state.tempUser);
        newState.working = false;
        newState.tempUser = initialState.selectedUser;
      }
      return newState;

    case 'ERROR':
      newState = Object.assign({}, state);
      newState.working = false;
      return newState;

    case user.CHECK_USERNAME_EXISTS:
      newState = Object.assign({}, state);
      newState.working = true;
      return newState;

    case user.CHECK_USERNAME_EXISTS_COMPLETE:
      newState = Object.assign({}, state);
      newState.working = false;
      newState.usernameExists = action.payload;
      return newState;

    case user.CHECK_EMAIL_EXISTS:
      newState = Object.assign({}, state);
      newState.working = true;
      return newState;

    case user.CHECK_EMAIL_EXISTS_COMPLETE:
      newState = Object.assign({}, state);
      newState.working = false;
      newState.emailExists = action.payload;
      return newState;

    case user.TOGGLE_ENABLED:
      newState = Object.assign({}, state);
      newState.working = true;
      return newState;

    case user.TOGGLE_ENABLED_COMPLETE:
      newState = Object.assign({}, state);
      newState.working = false;
      const users = newState.userPage.slice();
      const index = users.map(u => u.id).indexOf(action.payload);
      if (index > 0) {
        const usr = Object.assign({}, users[index]);
        usr.enabled = !usr.enabled;
        users.splice(index, 1, usr);
        newState.userPage = users.slice();
      }
      return newState;

    case auth.LOGOUT:
      return initialState;

    default:
      newState = Object.assign({}, state);
      return newState;
  }
}

export const getUserPage = (state: State) => state.userPage;
export const getUserPaging = (state: State) => state.paging;
export const getSelectedUsername = (state: State) => state.selectedUsername;
export const getSelectedUser = (state: State) => state.selectedUser;
export const getUserRoles = (state: State) => state.roles;
export const getIsNewUser = (state: State) => state.isNewUser;
export const getUserWorking = (state: State) => state.working;
export const getUsernameExists = (state: State) => state.usernameExists;
export const getEmailExists = (state: State) => state.emailExists;



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/reducers/user.ts